import { el } from "@dhx/ts-common/dom";
import { ICol, IRendererConfig, GridEvents, IEditor, IRow } from "../../types";

export class SelectEditor implements IEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _cell: { row: IRow; col: ICol };
	protected _config: IRendererConfig;
	protected _input: HTMLSelectElement;

	constructor(row: any, col: ICol, config: IRendererConfig) {
		this._config = config;
		this._cell = { row, col };

		this._initHandlers();
	}

	endEdit(withoutSave?: boolean) {
		let value: string | number;
		if (!withoutSave) {
			value = this._input.value;
		}
		if (this._config.events.fire(GridEvents.beforeEditEnd, [value, this._cell.row, this._cell.col])) {
			this._input.removeEventListener("blur", this._handlers.onBlur);
			this._input.removeEventListener("keydown", this._handlers.onkeydown);
			this._cell.row = this._config.datacollection.getItem(this._cell.row.id);
			this._config.events.fire(GridEvents.afterEditEnd, [value, this._cell.row, this._cell.col]);
		} else {
			this._input.focus();
		}
	}

	toHTML() {
		const content =
			this._cell.col.options.map(item => {
				return typeof item === "string" ? { id: `${item}`, value: item } : item;
			}) || [];
		let selected = this._cell.row[this._cell.col.id];
		if (this._input) {
			selected = this._input.options[this._input.selectedIndex].value;
		}
		const options = content.map(item => {
			return el(
				"option",
				{
					selected: item.id.toString() === selected.toString(),
					value: item.id,
				},
				item.value
			);
		});
		this._config.$editable.editor = this;
		return el(
			"select.dhx_cell-editor.dhx_cell-editor__select",
			{
				_hooks: {
					didInsert: this._handlers.didInsert,
				},
				_key: "cell_editor",
				"data-dhx-id": "cell_editor",
			},
			options
		);
	}

	protected _initHandlers() {
		this._handlers = {
			onBlur: () => {
				this.endEdit();
			},
			onkeydown: (e: KeyboardEvent) => {
				if (e.key === "Escape") {
					this.endEdit();
				}
			},
			didInsert: (node: any) => {
				const input = node.el;
				this._input = input;
				input.focus();
				input.addEventListener("blur", this._handlers.onBlur);
				input.addEventListener("keydown", this._handlers.onkeydown);
			},
		};
	}
}
